module.exports = __webpack_public_path__ + "img/ball2_db.ff0ea273.png";